<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { initTheme } from '@/utils/theme'
export default {
  name: 'App',
  created() { initTheme() }
}
</script>

<style>
/* ===== CSS 主题变量（默认森林绿） ===== */
:root {
  --primary:          #337537;
  --primary-dark:     #2A602E;
  --primary-darker:   #1C4A1F;
  --primary-light:    rgba(51, 117, 55, 0.08);
  --primary-tag-bg:   #E8F5E9;
  --primary-tag-border: #C8E6C9;
  --sidebar-gradient: linear-gradient(180deg, #1C4A1F 0%, #337537 100%);
}

* { margin: 0; padding: 0; box-sizing: border-box; }

body {
  font-family: 'Inter', 'PingFang SC', 'Microsoft YaHei', 'Hiragino Sans GB', -apple-system, BlinkMacSystemFont, sans-serif;
  background: #F8FAFC;
  color: var(--primary-darker);
  font-size: 13px;
}

/* 全局滚动条：固定 10px 占位，用透明边框模拟视觉粗细变化，hover 时加粗但不影响布局 */
::-webkit-scrollbar { width: 10px; height: 10px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: #D1D5DB; background-clip: content-box; border: 3px solid transparent; border-radius: 5px; transition: background 0.2s; }
::-webkit-scrollbar-thumb:hover { background: #475569; background-clip: content-box; border: 3px solid transparent; }
/* 鼠标移入含滚动的容器 → 滚动条视觉加粗（去边框，填满 10px），占位不变不跳动 */
*:hover::-webkit-scrollbar-thumb { background: #94A3B8; background-clip: content-box; border: none; border-radius: 5px; }
*:hover::-webkit-scrollbar-thumb:hover { background: #475569; background-clip: content-box; border: none; }
/* 弹框内不加粗，保持细滚动条视觉 */
.el-dialog *:hover::-webkit-scrollbar-thumb { background: #D1D5DB !important; background-clip: content-box !important; border: 3px solid transparent !important; border-radius: 5px !important; }
/* 下拉框不显示原生滚动条（Element UI 用自定义 scrollbar 组件），避免重叠 */
.el-scrollbar__wrap::-webkit-scrollbar { width: 0 !important; height: 0 !important; }
.el-scrollbar__wrap:hover::-webkit-scrollbar { width: 0 !important; height: 0 !important; }
.el-select-dropdown *:hover::-webkit-scrollbar { width: 0 !important; height: 0 !important; }
.el-autocomplete-suggestion *:hover::-webkit-scrollbar { width: 0 !important; height: 0 !important; }

/* ===== Element UI 全局覆盖 - 主色变量 ===== */
.el-button--primary {
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
}
.el-button--primary:hover,
.el-button--primary:focus {
  background-color: var(--primary-dark) !important;
  border-color: var(--primary-dark) !important;
}
.el-button:not([class*="el-button--"]):hover,
.el-button:not([class*="el-button--"]):focus,
.el-button--default:hover,
.el-button--default:focus {
  color: var(--primary) !important;
  border-color: var(--primary) !important;
  background-color: var(--primary-light) !important;
}
.el-button--text:hover,
.el-button--text:focus { color: var(--primary-dark) !important; }

/* ===== MessageBox 按钮：对齐弹框 取消/保存 风格 ===== */
.el-message-box__btns .el-button--default:not(.el-button--primary) {
  color: #606266 !important;
  background: #fff !important;
  border-color: #DCDFE6 !important;
}
.el-message-box__btns .el-button--default:not(.el-button--primary):hover,
.el-message-box__btns .el-button--default:not(.el-button--primary):focus {
  color: var(--primary) !important;
  background-color: var(--primary-light) !important;
  border-color: var(--primary) !important;
}
.el-message-box__btns .el-button--default:not(.el-button--primary):active {
  color: var(--primary-dark) !important;
  background-color: var(--primary-light) !important;
  border-color: var(--primary-dark) !important;
}
.el-message-box__btns .el-button--primary {
  color: #fff !important;
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
}
.el-message-box__btns .el-button--primary:hover,
.el-message-box__btns .el-button--primary:active {
  color: #fff !important;
  background-color: var(--primary-darker) !important;
  border-color: var(--primary-darker) !important;
}

.el-table th.el-table__cell {
  background-color: #F1F5F9 !important;
  color: #475569 !important;
  font-weight: 600;
}

/* ===== 修复 Element UI fixed 列重影问题 ===== */
.el-table__fixed td.el-table__cell {
  background-color: #fff !important;
}
.el-table__fixed .el-table__row--striped td.el-table__cell {
  background-color: #FAFAFA !important;
}
.el-table__fixed .el-table__row:hover > td.el-table__cell,
.el-table__fixed .el-table__row--striped:hover > td.el-table__cell {
  background-color: #F5F7FA !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: var(--primary) !important;
}

/* Tab 胶囊式 */
.el-tabs--border-card { background: transparent !important; border: none !important; box-shadow: none !important; border-radius: 0 !important; }
.el-tabs--border-card > .el-tabs__header { background: transparent !important; border-bottom: 1px solid #E2E8F0 !important; margin: 0 0 16px 0 !important; padding: 0 0 12px 0 !important; }
.el-tabs--border-card > .el-tabs__header .el-tabs__nav-wrap::after { display: none !important; }
.el-tabs--border-card > .el-tabs__header .el-tabs__item {
  height: 34px !important; line-height: 34px !important; padding: 0 20px !important;
  font-size: 13px !important; font-weight: 500 !important; color: #475569 !important;
  border: none !important; border-radius: 8px !important; background: transparent !important;
  margin: 2px 2px 0 0 !important; transition: all 0.25s ease !important;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__item:not(.is-active):hover {
  color: var(--primary) !important;
  background: var(--primary-light) !important;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #fff !important;
  background: var(--primary) !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.18) !important;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__active-bar { display: none !important; }
/* 禁用 tab 内容切换时的淡入淡出动画，避免表格闪烁 */
.el-tabs__content .el-tab-pane { animation: none !important; transition: none !important; opacity: 1 !important; }

/* Dialog */
.v-modal { background: rgba(15,23,42,0.4) !important; backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px); }
.el-dialog { border-radius: 16px !important; box-shadow: 0 20px 60px rgba(0,0,0,0.15) !important; overflow: hidden; }
.el-dialog__header { padding: 24px 28px 16px !important; border-bottom: 1px solid #F1F5F9; }
.el-dialog__title { font-size: 17px !important; font-weight: 700 !important; color: var(--primary-darker) !important; line-height: 1.4 !important; }
.el-dialog__headerbtn { top: 24px !important; right: 24px !important; width: 32px !important; height: 32px !important; border-radius: 8px !important; transition: all 0.2s ease; display: flex !important; align-items: center !important; justify-content: center !important; }
.el-dialog__headerbtn:hover { background: #F1F5F9; }
.el-dialog__close { font-size: 18px !important; font-weight: 700 !important; color: #94A3B8 !important; }
.el-dialog__headerbtn:hover .el-dialog__close { color: #475569 !important; }
.el-dialog__body { padding: 20px 28px !important; max-height: 68vh; overflow-y: auto; }
/* dialog body 继承全局滚动条 hover 行为，仅保留 thumb hover 加深色 */
.el-dialog__body::-webkit-scrollbar-thumb:hover { background: #475569 !important; background-clip: content-box !important; border: none !important; }
.el-dialog__footer { padding: 16px 28px 24px !important; border-top: 1px solid #F1F5F9; text-align: right !important; }
.el-dialog__footer .el-button + .el-button { margin-left: 10px; }

/* Checkbox / Radio / Switch */
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner,
.el-radio__input.is-checked .el-radio__inner {
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
}
.el-checkbox__input.is-indeterminate .el-checkbox__inner::before { background-color: #fff !important; }
.el-switch.is-checked .el-switch__core { border-color: var(--primary) !important; background-color: var(--primary) !important; }
.el-switch__label.is-active { color: var(--primary) !important; }
.el-checkbox.is-checked .el-checkbox__label { color: var(--primary) !important; }

/* Input / Select focus */
.el-input__inner:focus,
.el-textarea__inner:focus { border-color: var(--primary) !important; outline: none; }
.el-input__inner:hover,
.el-textarea__inner:hover { border-color: var(--primary) !important; }
.el-input.is-focus .el-input__inner { border-color: var(--primary) !important; }
.el-select .el-input.is-focus .el-input__inner,
.el-select .el-input__inner:focus { border-color: var(--primary) !important; }
.el-select-dropdown__item.selected { color: var(--primary) !important; font-weight: 600; }
.el-select-dropdown__item:hover { background-color: var(--primary-light) !important; }

/* Date picker */
/* hover 只着色 span（圆圈），不能把整个 td 变成色块 */
.el-date-table td.available:hover span {
  background-color: var(--primary) !important;
  color: #fff !important;
  border-radius: 50%;
}
.el-date-table td.current:not(.disabled) span {
  background-color: var(--primary) !important;
  color: #fff !important;
  border-radius: 50%;
}
.el-date-table td.today span { color: var(--primary) !important; font-weight: 700; }
.el-date-editor.el-input .el-input__inner:focus,
.el-date-editor.el-input .el-input__inner:hover { border-color: var(--primary) !important; }

/* Tags */
.el-tag--success { background-color: var(--primary-tag-bg) !important; color: var(--primary) !important; border-color: var(--primary-tag-border) !important; }

/* Loading */
.el-loading-spinner .el-loading-text,
.el-loading-spinner i { color: var(--primary) !important; }
</style>
